<div style="position: relative">
  <div>
    <div id="offerDetailsImage" class="carousel slide carouselCardImage" data-ride="carousel">
      <ol class="carousel-indicators" *ngIf="data.offerImageList.length > 1">
        <ng-container *ngFor="let img of data.offerImageList; let ii = index">
          <li [attr.data-target]="'#offerDetailsImage'" [attr.data-slide-to]="ii" [class.active]="ii == 0" *ngIf="img != ''"></li>
        </ng-container>
      </ol>
      <div class="carousel-inner carouselCardImageContainer">
        <ng-container *ngFor="let img of data.offerImageList; let ii = index">
          <div class="item carousel-item" [class.active]="ii == 0">
            <img
              [src]="assetsURL + 'offers/' + (data.offer | azurefolder) + '/' + (img | azurefolder) | azureBlobToken"
              [attr.alt]="data.offer"
              (error)="errorOfferImageHandler($event, ii)" />
          </div>
        </ng-container>
        <div class="item active" *ngIf="data.offerImageList.length == 0">
          <img [src]="AppInitializer.PropertyData?.UrlMap?.defaultOfferImageUrl | azureBlobToken" [attr.alt]="data.offer" />
        </div>
      </div>
      <ng-container *ngIf="data.offerImageList.length > 1">
        <a class="carousel-control-prev" [attr.href]="'#offerDetailsImage'" data-slide="prev">
          <i aria-hidden="true" class="carousel-control-prev-icon"></i>
        </a>
        <a class="carousel-control-next" [attr.href]="'#offerDetailsImage'" data-slide="next">
          <i aria-hidden="true" class="carousel-control-next-icon"></i>
        </a>
      </ng-container>
    </div>
  </div>

  <div class="offer_code">
    <strong>{{ rGuestBookMessages.offer.offerModalOfferCodeText }}</strong> {{ data.offer }}
  </div>
  <div class="card_title1">
    <h4 class="card_title_text pull-left" *ngIf="rGuestBookPermissions.functionalPermissions.disableCapitalizePipe">
      <span class="offer_detailsname">{{ data.offerDescription }}</span>
    </h4>
    <h4 class="card_title_text pull-left" *ngIf="!rGuestBookPermissions.functionalPermissions.disableCapitalizePipe">
      <span class="offer_detailsname">{{ data.offerDescription | capitalize }}</span>
    </h4>
  </div>
  <div class="mat-card-content-details">
    <div *ngIf="data.quickLook == true || data.arrivalDayFlag == true || data.offerTextArray?.length > 0">
      <div *ngIf="data.quickLook == true || data.arrivalDayFlag == true" class="panel panel-quickLook border border-primary mb-3">
        <div class="panel-heading dialog-panel-heading">
          <h3 class="panel-title dialog-panel-title">{{ rGuestBookMessages.offer.offerModalQuickLookText }}</h3>
        </div>
        <div class="panel-body custom-panel-body">
          <div class="container-fluid">
            <ul class="row">
              <li
                class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyEarliestArrival"
                *ngIf="data.earliestArrivalDate">
                <i class="quick_look fa fa-calendar-plus-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalEarliestArrDateText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.earliestArrivalDate | custDate: AppInitializer.PropertyData.dateFunctionConfig }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyLatestArrival" *ngIf="data.latestArrivalDate">
                <i class="quick_look fa fa-calendar-minus-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalLatestArrDateText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.latestArrivalDate | custDate: AppInitializer.PropertyData.dateFunctionConfig }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingStarts" *ngIf="data.earliestSalesDate">
                <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalBookingStartsText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.earliestSalesDate | custDate: AppInitializer.PropertyData.dateFunctionConfig }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingEnds" *ngIf="data.latestSalesDate">
                <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalBookingEndsText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.latestSalesDate | custDate: AppInitializer.PropertyData.dateFunctionConfig }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinNights" *ngIf="data.minimumNights">
                <i class="minimum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalMinNightsText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.minimumNights }}{{ rGuestBookMessages.offer.offerModalnightsText }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinPurchase" *ngIf="data.minimumAdvancePurchase">
                <i class="quick_look min-purchase fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalMinAdvancePurseText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.minimumAdvancePurchase }}{{ rGuestBookMessages.offer.offerModalDaysText }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxPurchase" *ngIf="data.maximumAdvancePurchase">
                <i class="quick_look max-purchase fa fa-arrow-circle-o-left" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalMaxAdvancePurseText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.maximumAdvancePurchase }}{{ rGuestBookMessages.offer.offerModalDaysText }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxNights" *ngIf="data.maximumNights">
                <i class="maximum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalMaxNightsText }}</p>
                <strong>
                  <p style="color: #607d8b; font-weight: 900">
                    {{ data.maximumNights }}{{ rGuestBookMessages.offer.offerModalnightsText }}
                  </p>
                </strong>
              </li>
              <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyNoArrival" *ngIf="data.arrivalDayFlag == true">
                <i class="quick_look fa fa-ban" aria-hidden="true"></i>
                <p>{{ rGuestBookMessages.offer.offerModalNoArrivalText }}</p>
                <div>
                  <div class="overflow_scroll">
                    <div class="day-display">
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Monday === false">
                        {{ "Mon" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Tuesday === false">
                        {{ "Tue" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Wednesday === false">
                        {{ "Wed" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Thursday === false">
                        {{ "Thu" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Friday === false">
                        {{ "Fri" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Saturday === false">
                        {{ "Sat" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                      <h5 class="display_button" *ngIf="data.arrivalDays[0].Sunday === false">
                        {{ "Sun" | custCalDayName: AppInitializer.PropertyData.dateFunctionConfig }}
                      </h5>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngIf="data.offerTextArray?.length > 0" class="panel panel-offer-detail border border-primary">
        <div class="panel-heading dialog-panel-heading" *ngIf="rGuestBookPermissions.functionalPermissions.disableCapitalizePipe">
          <h3 class="panel-title oferdetails_panel dialog-panel-title">{{ data.offerDescription }}</h3>
        </div>
        <div class="panel-heading dialog-panel-heading" *ngIf="!rGuestBookPermissions.functionalPermissions.disableCapitalizePipe">
          <h3 class="panel-title dialog-panel-title oferdetails_panel">{{ data.offerDescription | capitalize }}</h3>
        </div>
        <div [class.panel-body]="!offerConfigCloud" [class.offer-cloud]="offerConfigCloud">
          <div *ngFor="let description of data.offerTextArray">
            <p *ngIf="description?.length && !offerConfigCloud" style="margin: 0 0 10px">
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;<span [innerHTML]="description | safeHtml"></span>
            </p>
            <div *ngIf="description?.length && offerConfigCloud" [innerHTML]="description | safeHtml"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center" style="padding-bottom: 10px">
    <button
      color="primary"
      mat-dialog-close
      class="mobile-book-btn mr-1"
      (click)="checkAndBook(data)"
      mat-raised-button
      *ngIf="data.isOfferValid">
      {{ rGuestBookMessages.offer.OfferModalSelectOfferBtnText }}
    </button>
    <button
      color="primary"
      matTooltipPosition="above"
      matTooltip="{{ data.offerNotValidReason }} {{
        data.offerNotValidReason == 'Available for sale only from'
          ? (data.earliestSalesDate | date: 'EEEE, MMM d, y')
          : (data.latestSalesDate | date: 'EEEE, MMM d, y')
      }}"
      class="link-disabled mr-1"
      mat-raised-button
      *ngIf="!data.isOfferValid">
      {{ rGuestBookMessages.offer.OfferModalSelectOfferBtnText }}
    </button>
    <button class="mobile-book-btn mr-1" mat-dialog-close mat-raised-button color="warn">
      {{ rGuestBookMessages.offer.OfferModalCloseBtnText }}
    </button>
  </div>
</div>
